import { CurrentMoment } from '../../CurrentMoment';
import type { ColorPalette } from '../../ColorPalette';
import type { ScheduleEventInterface } from './ScheduleEventInterface';

/**
 * Shared schedule event behavior.
 */
export abstract class AbstractScheduleEvent implements ScheduleEventInterface {
	protected constructor(protected readonly colorPalette: ColorPalette) {}

	isCloserToNowThan(event: ScheduleEventInterface): boolean {
		return (
			this.getLatestScheduleEvent().getTime() >
			event.getLatestScheduleEvent().getTime()
		);
	}

	isCloserToNowInFutureThan(event: ScheduleEventInterface): boolean {
		return (
			this.getNextBoundaryAfter()! <
			event.getNextBoundaryAfter()!
		);
	}

	abstract getLatestScheduleEvent(): Date;

	abstract getNextBoundaryAfter(): number | null;

	getColorPalette(): ColorPalette {
		return this.colorPalette;
	}

	protected parseTime(time: string): { h: number; m: number } | null {
		return CurrentMoment.parseTime(time);
	}
}
